import { render, staticRenderFns } from "./petty-cash-review.vue?vue&type=template&id=64b57a83&scoped=true"
import script from "./petty-cash-review.vue?vue&type=script&lang=js"
export * from "./petty-cash-review.vue?vue&type=script&lang=js"
import style0 from "./petty-cash-review.vue?vue&type=style&index=0&id=64b57a83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b57a83",
  null
  
)

export default component.exports